module.exports = __webpack_public_path__ + "img/rocket.ac8413b0.svg";